// import React, { useState,useEffect } from 'react';
// import axios from 'axios'; 
// import SideMenu from './SideMenu';
// import Navbar from './Navbar';
// import Footer from './Footer';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
// // Modal component to display forms
// const Modal = ({ children, onClose }) => {
//   return (
    
     
//     <div className="modal">
//       <div className="modal-content">
//         {children}
//         <button className="close-modal" onClick={onClose}>
//           X
//         </button>
//       </div>
//     </div>
//   );
// };

// // Form component for adding a new user and assigning access
// const AssignAccessForm = ({ onSubmit, onClose }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     password:'',
//     role: '',
//     dashboardAccess: false,
//   });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === 'checkbox' ? checked : value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     onSubmit(formData);
//     setFormData({
//       name: '',
//       email: '',
//       password:'',
//       role: '',
//       dashboardAccess: false,
//     });
//   };

//   return (
//     <form onSubmit={handleSubmit} className="assign-access-form">
//       <h2>Assign Access</h2>
//       <label>
//         Name:
//         <input
//           type="text"
//           name="name"
//           value={formData.name}
//           onChange={handleChange}
//           required
//         />
//       </label>
//       <label>
//         Email:
//         <input
//           type="email"
//           name="email"
//           value={formData.email}
//           onChange={handleChange}
//           required
//         />
//       </label>
//       <label>
//         Password: {/* New Password field */}
//         <input
//           type="password"
//           name="password"
//           value={formData.password}
//           onChange={handleChange}
//           required
//         />
//       </label>
//       <label>
//         Role:
//         <select name="role" value={formData.role} onChange={handleChange} required>
//           <option value="">Select Role</option>
//           <option value="Admin">Admin</option>
//           <option value="Partners">Partners</option>
//           <option value="Team">Team</option>
//         </select>
//       </label>
//       <label>
//        Access
//         <input
//           type="checkbox"
//           name="dashboardAccess"
//           checked={formData.dashboardAccess}
//           onChange={handleChange}
//         />
       
//       </label>
//       <button type="submit">Submit</button>
     
//     </form>
//   );
// };

// // Main UserAccessPage component
// const UserAccessPage = () => {
//   const [users, setUsers] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [viewPasswordId, setViewPasswordId] = useState(null);

// //   const handleAddUser = (userData) => {
// //     setUsers([...users, { ...userData, id: users.length + 1 }]);
// //     setIsModalOpen(false);
// //   };

// //   const handleDeleteUser = (id) => {
// //     setUsers(users.filter((user) => user.id !== id));
// //   };


//  // Fetch users from backend API

//  useEffect(() => {
//     axios.get('http://localhost:5000/api/users') // Adjust URL as needed
//       .then((response) => {
//         setUsers(response.data);
//       })
//       .catch((error) => {
//         console.error('Error fetching users:', error);
//       });
//   }, []);

  
//   const handleAddUser = (userData) => {
//     axios.post('http://localhost:5000/api/add-user', userData) // Adjust URL as needed
//       .then((response) => {
//         // Add the new user to the state after it's added successfully
//         setUsers((prevUsers) => [...prevUsers, response.data.user]);
//         setIsModalOpen(false);
//       })
//       .catch((error) => {
//         console.error('Error adding user:', error);
//       });
//   };

 
//   const handleDeleteUser = (id) => {
//     axios.delete(`http://localhost:5000/api/delete-user/${id}`) // Adjust URL as needed
//       .then(() => {
//         setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
//       })
//       .catch((error) => {
//         console.error('Error deleting user:', error);
//       });
//   };

  
//   const toggleViewPassword = (id) => {
//     setViewPasswordId(viewPasswordId === id ? null : id); 
//   };


//   return (
//     <div>
// <Navbar/>
//     <div className='middle'>
//         <SideMenu/>
  
    
//     <div className="user-access-page">
//       <h1>User Access Management</h1>
//       <button onClick={() => setIsModalOpen(true)}>+ Add User</button>
      
//       {/* Modal for adding new user */}
//       {isModalOpen && (
//         <Modal onClose={() => setIsModalOpen(false)}>
//           <AssignAccessForm onSubmit={handleAddUser} onClose={() => setIsModalOpen(false)} />
//         </Modal>
//       )}

//       {/* User Table */}
//       <table className='user-table'>
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>Email</th>
//             <th>Password</th>
//             <th>Role</th>
//             <th>Access</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {users.map((user) => (
//             <tr key={user.id}>
//               <td>{user.name}</td>
//               <td>{user.email}</td>
//               {/* <td>{user.password}</td>  */}
//               <td>
//                     {viewPasswordId === user.id ? (
//                       user.password
//                     ) : (
//                       '••••••••'
//                     )}
//                     <FontAwesomeIcon
//                       icon={viewPasswordId === user.id ? faEyeSlash : faEye}
//                       onClick={() => toggleViewPassword(user.id)}
//                       style={{
//                         cursor: 'pointer',
//                         marginLeft: '10px',
//                       }}
//                     />
//                   </td>
//               <td>{user.role}</td>
//               <td>{user.dashboardAccess ? 'Yes' : 'No'}</td>
//               <td>
//                 <button onClick={() => handleDeleteUser(user.id)}>Delete</button>
//               </td>

//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
         
         
    
//     </div >
//     <div>
//         <Footer/>
//     </div>
//     </div>
//   );
// };

// export default UserAccessPage;





// RBAC

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideMenu from './SideMenu';
import Navbar from './Navbar';
import Footer from './Footer';
import { FaUser , FaTrash} from 'react-icons/fa'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Modal component for displaying forms
const Modal = ({ children, onClose }) => {
  return (
    <div className="modal">
      <div className="modal-content">
        {children}
        <button className="close-modal" onClick={onClose}>
          X
        </button>
      </div>
    </div>
  );
};

// Form component for adding a new user and assigning access
const AssignAccessForm = ({ onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role: '',
    // dashboardAccess: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({
      name: '',
      email: '',
      password: '',
      role: '',
      // dashboardAccess: false,
    });
    onClose();
  };

  return (
    <form onSubmit={handleSubmit} className="assign-access-form">
      <h2>Assign Access</h2>
      <label>
        Name:
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Email:
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Password:
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Role:
        <select name="role" value={formData.role} onChange={handleChange} required>
          <option value="">Select Role</option>
          <option value="Admin">Admin</option>
          <option value="Partners">Partners</option>
          <option value="Team">Team</option>
        </select>
      </label>
      {/* <label>
        Dashboard Access:
        <input
          type="checkbox"
          name="dashboardAccess"
          checked={formData.dashboardAccess}
          onChange={handleChange}
        />
      </label> */}
      <button type="submit">Submit</button>
    </form>
  );
};

// Main UserAccessPage component
const UserAccessPage = () => {
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewPasswordId, setViewPasswordId] = useState(null);

  const loggedInUserRole = localStorage.getItem('role');

  // Fetch users from backend API
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/users`) // Adjust URL as needed
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        console.error('Error fetching users:', error);
      });
  }, []);

  const handleAddUser = (userData) => {
    axios
      .post(`${API_BASE_URL}/api/add-user`, userData)
      .then((response) => {
        setUsers((prevUsers) => [...prevUsers, response.data.user]);
        setIsModalOpen(false);
      })
      .catch((error) => {
        console.error('Error adding user:', error);
      });
  };

  // const handleUpdateUser= (id)=>{

  // }


  const handleDeleteUser = (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this user?');
  
    if (confirmDelete) {
      const loggedInUserEmail = localStorage.getItem('loggedInUserEmail'); // Retrieve logged-in user's email
  
      // Ensure logged-in user email is present
      if (!loggedInUserEmail) {
        alert('User not logged in or email not found.');
        return;
      }
  
      axios
        .delete(`${API_BASE_URL}/api/delete-user/${id}`, {
          headers: {
            Authorization: `Bearer ${loggedInUserEmail}`,
          },
        })
        .then(() => {
          setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
          alert('User deleted successfully.');
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            alert('You do not have permission to delete this user.');
          } else if (error.response && error.response.status === 403) {
            alert('Only Admins can delete users.');
          } else {
            alert('An error occurred while deleting the user. Please try again.');
          }
          console.error('Error deleting user:', error);
        });
    }
  };

  

  const toggleViewPassword = (id) => {
    setViewPasswordId(viewPasswordId === id ? null : id);
  };
  // const toggleViewPassword = (id) => {
  //   // Only allow toggling password visibility if the user is an Admin
  //   if (loggedInUserRole === 'Admin') {
  //     setViewPasswordId(viewPasswordId === id ? null : id);
  //   } else {
  //     alert('You do not have permission to view passwords.');
  //   }
  // };

  return (
    <div>
      <Navbar />
      <div className="middle">
        <SideMenu />
        <div className='user-h'> <h1>User Access Management</h1></div>
        <div className="user-access-page">
        {/*          
          <div className='adduser' onClick={() => setIsModalOpen(true)}
          disabled={loggedInUserRole !== 'Admin'}>
              <FaUser />+
          </div> */}

          {loggedInUserRole === 'Admin' && (
                <div className="adduser" onClick={() => setIsModalOpen(true)}>
                      <FaUser />+
                </div>
         )}

          {isModalOpen && (
            <Modal onClose={() => setIsModalOpen(false)}>
              <AssignAccessForm onSubmit={handleAddUser} onClose={() => setIsModalOpen(false)} />
            </Modal>
          )}

          <table className="user-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Password</th>
                <th>Role</th>
                {/* <th>Access</th> */}
                {/* <th>Action</th> */}
                {loggedInUserRole === 'Admin' && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.name}</td> 
                  <td>{user.email}</td>
                  <td>
                    {viewPasswordId === user.id ? user.password : '••••••••'}
                    {loggedInUserRole === 'Admin' && (
                    <FontAwesomeIcon
                      icon={viewPasswordId === user.id ? faEyeSlash : faEye}
                      onClick={() => toggleViewPassword(user.id)}
                      style={{ cursor: 'pointer', marginLeft: '10px' }}
                    />
                    )}
                  </td>
                  <td>{user.role}</td>
                  {/* <td>{user.dashboardAccess ? 'Yes' : 'No'}</td> */}
                  <td>
                  {/* {loggedInUserRole === 'Admin' &&(
                    <div className='Action' onClick={()=>handleUpdateUser(user.id)}>
                    <FaEdit /> */}
                  
                    <div onClick={() => handleDeleteUser(user.id)}>
                      <FaTrash />
                    </div>
                    {/* </div> */}
                  {/* )} */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserAccessPage;
